import courseUnits from "./data/course-units.json";
import type { CourseUnit } from "./types";

export const DEFAULT_UNITS = courseUnits as CourseUnit[];

export function mergeCourseUnits(saved: CourseUnit[]): CourseUnit[] {
  const byId = new Map(saved.map((unit) => [unit.id, unit]));
  return DEFAULT_UNITS.map((unit) => ({ ...unit, ...byId.get(unit.id) })).sort((a, b) => a.week - b.week);
}
